import React, { useState } from 'react';

import UpgradeECALPlanDialog from '.';
import useConfirmationDialogV2 from '../../../../../../commons/dialogV2/useConfirmationDialogV2';

function useUpgradePlanDialog (props = {}) {
    const { open: defaultOpen = false, onlyPlanId, onUpgraded, title, currency, ctaLabel } = props;

    const [open, setOpen] = useState(defaultOpen);

    const { openDialog: openSuccessDialog, renderDialog: renderSuccessDialog } = useConfirmationDialogV2({
        onConfirm: onUpgraded,
        onClose: onUpgraded, // Escape/backdrop dismissal must not skip the post-success callback (e.g. signup's redirect)
        showPrimaryButton: true,
        showSecondaryButton: false,
        confirmLabel: 'Ok',
    });

    function renderUpgradePlanDialog () {
        return (
            <React.Fragment>
                {open && (
                    <UpgradeECALPlanDialog
                        open={open}
                        onClose={() => {
                            setOpen(false);
                        }}
                        onlyPlanId={onlyPlanId}
                        onPaymentSuccess={openSuccessDialog}
                        title={title}
                        currency={currency}
                        ctaLabel={ctaLabel}
                    />
                )}
                {renderSuccessDialog()}
            </React.Fragment>
        );
    }

    function openDialog () {
        setOpen(true);
    }

    return {
        renderUpgradePlanDialog,
        openDialog,
    };
}

export default useUpgradePlanDialog;
